export const TIN_PLACEHOLDER = 'XXX-XXX-XXX-XXXXX';

/**
 * Validate a TIN string. Returns null when valid or empty, otherwise an error message.
 * Accepts only 9 or 14 digit TINs (after stripping non-digits).
 */
export function validateTin(value: string): string | null {
  const digitsOnly = value.replace(/\D/g, '');
  if (!digitsOnly) return null; // allow empty TIN
  if (digitsOnly.length === 9 || digitsOnly.length === 14) {
    return null;
  }
  return 'TIN must be exactly 9 or 14 digits.';
}

/**
 * Format TIN to XXX-XXX-XXX-XXXXX.
 * - For 9-digit TINs, pads the last block to 00000.
 * - For 14-digit TINs, uses the remaining 5 digits (padded if shorter).
 * - Returns the original value when it cannot be formatted.
 */
export function formatTinForInput(value: string): string {
  const digits = value.replace(/\D/g, '');
  if (!digits) return '';
  if (digits.length !== 9 && digits.length !== 14) return value;

  const part1 = digits.slice(0, 3);
  const part2 = digits.slice(3, 6);
  const part3 = digits.slice(6, 9);
  const part4 =
    digits.length === 9 ? '00000' : digits.slice(9, 14).padEnd(5, '0');

  return `${part1}-${part2}-${part3}-${part4}`;
}
